var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('plan-calendar',{on:{"handleSelectDay":_vm.handleSelectDay,"handleClickItem":_vm.handleClickItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }